import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';


export class DanoneMslProduct extends BaseEntity {

  icon        : string = null;
  geoAreaCode : string;
  product     : Product = new Product();
  rank1       : number;
  rank2       : number;
  rank3       : number;

  constructor() {
    super();

  }
}
